module.exports = __webpack_public_path__ + "static/media/Desafio7-c.434e0a3e.mp4";